module.exports = __webpack_public_path__ + "static/media/Blue_Cap.8f7f480c.webp";